import ServiceLocator from "../global/service-locator";

const initCoachInfo = ($coachCard) => {
	const $modal = ServiceLocator.instance.modalService.getItem('coach-info').$root;
	const $oldCoachInfo = $modal.querySelector('.coach-info');
	const $newCoachInfo = $coachCard.nextElementSibling;

	if ($oldCoachInfo.dataset.id !== $newCoachInfo.dataset.id) {
		$oldCoachInfo.remove();
		const newCoachInfoCopy = $coachCard.nextElementSibling.cloneNode(true);
		newCoachInfoCopy.classList.remove('-hidden');
		$modal.append(newCoachInfoCopy);
		lozadObserver.observe();
	}
};

export {
	initCoachInfo
};